import { useQuery } from '@tanstack/react-query';
import { listInvites } from '../api/team.api';
import { pendingInvitesPollInterval } from '../pending-invites-poll';
import { teamKeys } from './team.keys';

interface UseTeamInvitesOptions {
  /**
   * Re-poll while any invite is pending, so an accepted invite drops off the
   * roster without a manual refresh (Team Access page, UX sheet r244). Off by
   * default: other readers (e.g. the dashboard snapshot) do not need it.
   */
  pollWhilePending?: boolean;
}

/**
 * Load the entity's open (pending/expired) invites (MYN-43). Merged with
 * members in the Team table so invited-but-not-joined people show as pending.
 */
export function useTeamInvites(
  entityId: string | undefined,
  { pollWhilePending = false }: UseTeamInvitesOptions = {},
) {
  return useQuery({
    queryKey: teamKeys.invites(entityId ?? ''),
    queryFn: () => listInvites(),
    enabled: Boolean(entityId),
    refetchInterval: pollWhilePending
      ? (query) => pendingInvitesPollInterval(query.state.data)
      : false,
  });
}
